export default __webpack_public_path__ + "static/publicis-sapient-logo-0cc7f66411c1e6774122bc407cbb56d4.svg";